module.exports = __webpack_public_path__ + "img/exp.febaeca6.svg";